import { createGetDataReducer } from "./CommonReducer";
import { CATEGORYLIST , CATEGORYADD , CATEGORYSTATUS , CATEGORYDELETE, CATEGORYDETAILS, CATEGORYUPDATE } from "../../Constants/Category";

export const CategoryGetReducer = createGetDataReducer( CATEGORYLIST );
export const CategoryAddReducer = createGetDataReducer( CATEGORYADD );
export const CategoryStatusReducer = createGetDataReducer( CATEGORYSTATUS );
export const CategoryDeleteReducer = createGetDataReducer(CATEGORYDELETE)
export const CategoryDetailsReducer = createGetDataReducer(CATEGORYDETAILS)
export const CategoryUpdateReducer = createGetDataReducer(CATEGORYUPDATE)


